import React from "react";

import { Form, Row, Col, InputGroup, FormText } from "react-bootstrap";
import {
  IconBuilding,
  IconLabel,
  IconArticle,
  IconUser,
  IconMail,
  IconPhone,
  IconDeviceMobile,
  IconPrinter,
  IconNotes,
  IconFileDescription,
  IconWorldWww,
  IconUserFilled,
} from "@tabler/icons-react";
import { useFormContext } from "react-hook-form";
import PhoneInput from "react-phone-number-input";
import { Controller } from "react-hook-form";
import "react-phone-number-input/style.css";
import { handleKeyDown } from "../../constant/_constant";
const VendorFormStep1 = ({ isEditing }) => {
  const {
    control,
    register,
    formState: { errors },
  } = useFormContext();

  console.log("errors", errors);

  return (
    <>

      <Row className="mb-3 mt-3">
        <Form.Group as={Col}>
          <div style={{ display: "flex", gap: "2px 18px", flexWrap: "wrap" }}>
            <Form.Label
              className="d-inline-block d-sm-inline w-100 w-sm-auto"
              style={{ fontWeight: "bold" }}
            >
              Vendor Type:
            </Form.Label>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="VENDORId"
                value="vendor"
                {...register("vendor_type")}
              />
              <Form.Check.Label htmlFor="VENDORId">Vendor</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="VENDORId"
                value="manufacturer"
                {...register("vendor_type")}
              />
              <Form.Check.Label htmlFor="VENDORId">Manufacturer</Form.Check.Label>
            </Form.Check>

            <Form.Check>
              <Form.Check.Input
                type="radio"
                id="VENDORId"
                value="both"
                {...register("vendor_type")}
              />
              <Form.Check.Label htmlFor="VENDORId">Both</Form.Check.Label>
            </Form.Check>

          </div>
        </Form.Group>
      </Row>

      <Row>

        {isEditing && (
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label >Vendor code</Form.Label>
              <InputGroup>
                <InputGroup.Text>
                  <IconMail stroke={1} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  {...register("vendor_code")}
                  // placeholder="Enter Vendor Code"

                  disabled
                />
              </InputGroup>
              {errors.vendor_code && (
                <span className="text-danger">
                  {errors.vendor_code.message}
                </span>
              )}
            </Form.Group>
          </Col>
        )}

        <Col md={isEditing ? 4 : 6}>
          <Form.Group>
            <Form.Label className="required">Company Name</Form.Label>
            <Controller
              name="display_name"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  placeholder="Company Name"
                  isInvalid={!!errors.display_name}
                />
              )}
            />
            {errors.display_name && (
              <Form.Control.Feedback type="invalid">
                {errors.display_name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        <Col md={isEditing ? 4 : 6}>
          <Form.Group as={Col} controlId="formWebsite" className="mb-3">
            <Form.Label>Website</Form.Label>
            <InputGroup>
              <Controller
                name="website"
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="text"
                    placeholder="Enter Website URL"
                    isInvalid={!!errors?.website}
                  />
                )}
              />
              <InputGroup.Text>
                <IconWorldWww stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors?.website && (
              <Form.Text className="text-danger">
                {errors.website.message}
              </Form.Text>
            )}
          </Form.Group>
        </Col>


      </Row>

      {/* <Row>
        <Col md={6}>
          <Form.Group>
            <Form.Label className="required">Company Name</Form.Label>
            <Controller
              name="display_name"
              control={control}
              render={({ field }) => (
                <Form.Control
                  {...field}
                  placeholder="Company Name"
                  isInvalid={!!errors.display_name}
                />
              )}
            />
            {errors.display_name && (
              <Form.Control.Feedback type="invalid">
                {errors.display_name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group as={Col} controlId="formWebsite" className="mb-3">
            <Form.Label>Website</Form.Label>
            <InputGroup>
              <Controller
                name="website"
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    type="text"
                    placeholder="Enter Website URL"
                    isInvalid={!!errors?.website}
                  />
                )}
              />
              <InputGroup.Text>
                <IconWorldWww stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors?.website && (
              <Form.Text className="text-danger">
                {errors.website.message}
              </Form.Text>
            )}
          </Form.Group>
        </Col>
      </Row> */}

      <Row>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>First Name</Form.Label>
            <InputGroup>
              <Controller
                name="first_name"
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    isInvalid={!!errors.first_name}
                    placeholder="Enter First Name"
                  />
                )}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>

            {errors.first_name && (
              <Form.Control.Feedback type="invalid">
                {errors.first_name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>

        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Last Name</Form.Label>
            <InputGroup>
              <Controller
                name="last_name"
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}
                    isInvalid={!!errors.last_name}
                    placeholder="Enter Last Name"
                  />
                )}
              />
              <InputGroup.Text>
                <IconUser stroke={1} />
              </InputGroup.Text>
            </InputGroup>

            {errors.last_name && (
              <Form.Control.Feedback type="invalid">
                {errors.last_name.message}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <InputGroup>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <Form.Control
                    {...field}

                    placeholder="Enter Email"
                  />
                )}
              />
              <InputGroup.Text>
                <IconMail stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {errors?.email && (
              <Form.Text className="text-danger">
                {errors.email.message}
              </Form.Text>
            )}

            {/* {errors.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email.message}
                </Form.Control.Feedback>
              )} */}
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group className="mb-3">
            <Form.Label>Phone Number</Form.Label>
            <InputGroup>
              <InputGroup.Text>
                <IconPhone stroke={1} />
              </InputGroup.Text>
              <Controller
                name="phone_number"
                control={control}
                rules={{
                  required: "Phone number is required",
                  validate: (value) =>
                    (value && value.length > 0) || "Invalid phone number",
                }}
                render={({ field }) => (
                  <PhoneInput
                    className="form-control"
                    {...field}
                    defaultCountry="US"
                    countryCallingCodeEditable={false}
                    international
                    placeholder="Enter phone number"
                    onChange={field.onChange}
                  />
                )}
              />
            </InputGroup>
            {errors.phone_number && (
              <span className="text-danger">
                {errors.phone_number.message}
              </span>
            )}
          </Form.Group>
        </Col>

        {/* <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <InputGroup>
                <Controller
                  name="phone_number"
                  control={control}
                  render={({ field }) => (
                    //   <PhoneInput
                    //   {...field}
                    //   international
                    //   defaultCountry="US"
                    //   value={formData.phone_number || ""}
                    //   onChange={(e,value) => {
                    //     console.log('Phone Input Value:', value);
                    //     // field.onChange(value);

                    //     handleFormChange(e,value);
                    //   }}
                    //   className="phone-input"
                    //   placeholder="Enter Phone Number"
                    // />
                    <Form.Control
                      {...field}
                      type="number"
                      onKeyDown={handleKeyDown}
                      value={formData.phone_number || ""}
                      onChange={(e) => {
                        field.onChange(e);
                        handleFormChange(e);
                      }}
                      // isInvalid={!!errors.phone_number}
                      placeholder="Enter Phone Number"
                    />
                  )}
                />
                <InputGroup.Text>
                  <IconPhone stroke={1} />
                </InputGroup.Text>
              </InputGroup>

              {errors?.phone_number && (
                <Form.Text className="text-danger">
                  {errors.phone_number.message}
                </Form.Text>
              )}

              {errors.phone_number && (
                <Form.Control.Feedback type="invalid">
                  {errors.phone_number.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>
          </Col> */}

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <InputGroup>
              <Controller
                name="Address"
                control={control}
                render={({ field }) => (
                  <>
                    <Form.Control
                      {...field}
                      as="textarea"
                      placeholder="Enter Address"
                      style={{
                        height: "auto",
                        minHeight: "80px",
                        resize: "none",
                      }}
                      onInput={(e) => {
                        e.target.style.height = "auto";
                        e.target.style.height = `${e.target.scrollHeight}px`;
                      }}
                    />

                  </>
                )}
              />
              <InputGroup.Text>
                <IconFileDescription stroke={1} />
              </InputGroup.Text>
            </InputGroup>
            {/* {errors.Address && (
                        <span className="text-danger">
                          {errors.Address.message}
                        </span>
                      )} */}
            {errors.Address && (
              <span className="text-danger">{errors.Address.message}</span>
            )}
          </Form.Group>
        </Col>
      </Row>



    </>
  );
};

export default VendorFormStep1;
